export function industriesAnimation() {
    const $window = $(window);
    let $windowWidth = $window.width();
    const $windowHeight = $window.height();
    const industriesImage = $(".main-industries-image");
    const industriesWrap = $(".industries-content");
    const industries = industriesWrap.find("li");

    $window.on("scroll load", function () {
        if ($windowWidth > 767) {
            let scrollTop = $(document).scrollTop();
            industries.each(function () {
                const $this = $(this);
                const itemOffsetTop = $this.offset().top;
                const itemHeight = $this.outerHeight(true);
                const imageSrc = $this.find('img').attr('src');

                if ((scrollTop + $windowHeight / 2 >= itemOffsetTop) && (scrollTop + $windowHeight / 2 <= itemOffsetTop + itemHeight)) {
                    if (!$this.hasClass('active')) {
                        $this.siblings().removeClass('active');
                        $this.addClass('active');
                        industriesImage.removeClass('active');
                        setTimeout(() => {
                            if (imageSrc) {
                                industriesImage.attr("src", imageSrc);
                                industriesImage.addClass('active');
                            }
                        }, 400);
                    }
                } else {
                    // $this.removeClass('active');
                }
            });
        }
    });

    $window.on('resize', function () {
        $windowWidth = $window.width();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/industriesAnimation.js